module.exports = __webpack_public_path__ + "static/img/1.8403342.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/1.png
// module id = 81ET
// module chunks = 0